import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import PropTypes from "prop-types";

import { Button } from "@lululemon/ecom-pattern-library-button";
import { ColorSwatch } from "@lululemon/ecom-pattern-library-color-swatch";
import { LoadingIndicator } from "@lululemon/ecom-pattern-library-loading-indicator";

import styles from "./signposting.module.scss";

const Signposting = ({
  colorCode,
  colorName,
  ctaDisabled,
  ctaLabel,
  ctaProps,
  ctaRef,
  inseam,
  isCtaProcessing,
  isMobileOrTablet,
  isSelectedSizeInStock,
  onCtaClick,
  show,
  showColor,
  size,
  title
}) => {
  const [mounted, setMounted] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const signpostingEl = document.getElementById("signposting");

  useEffect(() => {
    if (signpostingEl) {
      if (show) {
        setVisibility(true);
      } else {
        setTimeout(() => {
          setVisibility(false);
        }, 600);
      }
    }

    setMounted(true);
  }, [show, signpostingEl, visibility]);

  if (!(signpostingEl && mounted)) {
    return null;
  }

  return ReactDOM.createPortal(
    <div
      className={classNames("OneLinkTx", styles.signposting, {
        [styles.fadeIn]: show,
        [styles.visible]: visibility
      })}
    >
      <div className={classNames(styles.wrapper)}>
        <div>
          <h3 className={`${styles.title} OneLinkNoTx`}>{title}</h3>
        </div>
        {!isMobileOrTablet && (
          <div className={styles.rightSide}>
            {showColor && (
              <>
                <span className={`${styles.rightSideLabel} OneLinkTx`}>
                  Colour:&nbsp;
                </span>
                <div className={styles.colorWrapper}>
                  <ColorSwatch
                    id={colorCode}
                    name={colorName}
                    className={`${styles.colorSwatch} OneLinkTx`}
                  />
                  <div className={`${styles.colorTooltip} OneLinkTx`}>
                    {colorName}
                  </div>
                </div>
              </>
            )}
            {isSelectedSizeInStock && (
              <>
                <span className={`${styles.rightSideLabel} OneLinkTx`}>
                  Size:&nbsp;
                </span>
                <span className={styles.rightSideValue}>{size}</span>
              </>
            )}
            {inseam && (
              <>
                <span className={`${styles.rightSideLabel} OneLinkTx`}>
                  Length:&nbsp;
                </span>
                <span className={styles.rightSideValue}>{inseam}</span>
              </>
            )}
            <Button
              className={classNames(styles.cta, "OneLinkTx", {
                [styles.ctaProcessing]: isCtaProcessing
              })}
              variant="filledImpact"
              onClick={onCtaClick}
              disabled={ctaDisabled}
              ref={ctaRef}
              {...ctaProps}
            >
              {isCtaProcessing ? (
                <LoadingIndicator
                  className={styles.ctaLoadingIndicator}
                  color="white"
                />
              ) : (
                ctaLabel
              )}
            </Button>
          </div>
        )}
      </div>
    </div>,
    signpostingEl
  );
};

Signposting.defaultProps = {
  ctaDisabled: false,
  ctaProps: {},
  inseam: "",
  size: "",
  title: ""
};

Signposting.propTypes = {
  colorCode: PropTypes.string.isRequired,
  colorName: PropTypes.string.isRequired,
  ctaDisabled: PropTypes.bool,
  ctaLabel: PropTypes.string.isRequired,
  ctaProps: PropTypes.shape({}),
  ctaRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]).isRequired,
  inseam: PropTypes.string,
  isCtaProcessing: PropTypes.bool.isRequired,
  isMobileOrTablet: PropTypes.bool.isRequired,
  isSelectedSizeInStock: PropTypes.bool.isRequired,
  onCtaClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  showColor: PropTypes.bool.isRequired,
  size: PropTypes.string,
  title: PropTypes.string
};

export default Signposting;
